import { Button, TextField } from '@/components/Common';
import { IconPosition, TextfieldType } from '@/components/Common/TextField/TextField.types';
import { Modal } from '@/components/Layout';
import iconNinea from '@/assets/icons/ninea.svg';
import iconCompany from '@/assets/icons/company.svg';
import iconAddress from '@/assets/icons/address.svg';
import iconPhone from '@/assets/icons/tel.svg';
import iconEmail from '@/assets/icons/mail.svg';
import { useCompany } from './company.hook';
import { useCompanyStore } from '@/store/CompanyStore/CompanyStore';
export const CompanyForm = () => {
  const { handleSubmit, register, errors, handleAddCompany, isAddingCompany } = useCompany();
  const { isOpenCompanyModal, openCompanyModal } = useCompanyStore();
  return (
    <Modal
      isOpen={isOpenCompanyModal}
      onClose={openCompanyModal}
      modalStyle="bg-bgModal"
      headerStyle="bg-bgModal h-[36px]"
    >
      <div className="w-[375px]">
        <div className="flex flex-col justify-center items-center mb-5">
          <h1 className="text-primary text-xl font-bold">
            Ajouter une entreprise
          </h1>
          <h5 className='text-xs pt-0 mt-0 text-[#9FA9B2]'>Information sur l’entreprise</h5>
        </div>
        <form onSubmit={handleSubmit(handleAddCompany)} className='max-w-[308px] mx-auto'>
          <div className="flex flex-col gap-y-1">
            <TextField
              className="mb-0 placeholder:text-iconColor"
              borderStyle='!bg-almostBlack pl-[22px]'
              register={register("name")}
              placeholder="Nom de l'entreprise"
              textFieldType={TextfieldType.INPUT}
              icon={<img src={iconCompany} alt="company" />}
              iconPosition={IconPosition.LEFT}
              helpText={errors.name?.message}
              errorStyle="!text-red-500"
            />
            <TextField
              className="mb-0 placeholder:text-iconColor"
              borderStyle='!bg-almostBlack pl-[22px]'
              register={register("phoneNumber")}
              placeholder="Numéro de téléphone"
              textFieldType={TextfieldType.INPUT}
              icon={<img src={iconPhone} alt="phone" />}
              iconPosition={IconPosition.LEFT}
              helpText={errors.phoneNumber?.message}
              errorStyle="!text-red-500"
            />
            <TextField
              className="mb-0 placeholder:text-iconColor"
              borderStyle='!bg-almostBlack pl-[22px]'
              register={register("address")}
              placeholder="Adresse"
              textFieldType={TextfieldType.INPUT}
              icon={<img src={iconAddress} alt="address" />}
              iconPosition={IconPosition.LEFT}
              helpText={errors.address?.message}
              errorStyle="!text-red-500"
            />
            <TextField
              className="mb-0 placeholder:text-iconColor"
              borderStyle='!bg-almostBlack pl-[22px]'
              register={register("email")}
              placeholder="Email"
              textFieldType={TextfieldType.INPUT}
              icon={<img src={iconEmail} alt="email" />}
              iconPosition={IconPosition.LEFT}
              helpText={errors.email?.message}
              errorStyle="!text-red-500"
            />
            <TextField
              className="mb-0 placeholder:text-iconColor"
              borderStyle='!bg-almostBlack pl-[22px]'
              register={register("ninea")}
              placeholder="Ninéa"
              textFieldType={TextfieldType.INPUT}
              icon={<img src={iconNinea} alt="ninea" />}
              iconPosition={IconPosition.LEFT}
              helpText={errors.ninea?.message}
              errorStyle="!text-red-500"
            />
          </div>
          <div className='w-full flex justify-center items-center mt-14'>
            <Button
              type='submit'
              title={isAddingCompany ? 'Ajout en cours...' : 'Ajouter'}
              className='w-full'
            />
          </div>
        </form>
      </div>
    </Modal>
  );
};
